import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../utils/api';
import './Auth.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await api.post('/auth/forgot-password', { email });
      setSuccess(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to send reset email. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="auth-page student-auth">
        <div className="auth-container">
          <div className="auth-header">
            <div className="role-icon student-icon">✉️</div>
            <h1>Check Your Email</h1>
            <p>We've sent password reset instructions to your email address</p>
          </div>

          <div className="success-message">
            <p>If an account exists with <strong>{email}</strong>, you will receive a password reset link shortly.</p>
            <p>Please check your inbox and spam folder.</p>
          </div>

          <div className="auth-links" style={{ marginTop: '30px' }}>
            <Link to="/login" className="btn-primary btn-student" style={{ textAlign: 'center', textDecoration: 'none', display: 'block', padding: '12px' }}>
              Back to Login
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page student-auth">
      <div className="auth-container">
        <div className="auth-header">
          <div className="role-icon student-icon">🔑</div>
          <h1>Forgot Password</h1>
          <p>Enter your email to reset your password</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email Address</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
            />
          </div>

          {error && <div className="error">{error}</div>}

          <button type="submit" className="btn-primary btn-student" disabled={loading}>
            {loading ? 'Sending...' : 'Send Reset Link'}
          </button>

          <p className="auth-link">
            Remember your password? <Link to="/login">Sign in</Link>
          </p>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
